import { render, staticRenderFns } from "./VDropdown.vue?vue&type=template&id=0d536bd8&scoped=true"
import script from "./VDropdown.vue?vue&type=script&lang=js"
export * from "./VDropdown.vue?vue&type=script&lang=js"
import style0 from "./VDropdown.vue?vue&type=style&index=0&id=0d536bd8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d536bd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d536bd8')) {
      api.createRecord('0d536bd8', component.options)
    } else {
      api.reload('0d536bd8', component.options)
    }
    module.hot.accept("./VDropdown.vue?vue&type=template&id=0d536bd8&scoped=true", function () {
      api.rerender('0d536bd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/volta/VDropdown.vue"
export default component.exports